import React from "react";
import ControlCameraIcon from "@material-ui/icons/ControlCamera";

function DirektanUpitIcon(props) {
  return <ControlCameraIcon {...props}/>;
}

export default DirektanUpitIcon;
